<template>
  <v-scale-transition>
    <div ref="tooltip" class="tooltip-message" v-show="value">
      <v-card :style="{background: $store.getters.isDarkTheme ? 'rgba(0, 0, 0, 0.6)' : 'rgba(255, 255, 255, 0.6)'}">
        <v-card-text class="pa-2">
          <h4 v-html="tooltipMessage"></h4>
        </v-card-text>
      </v-card>
    </div>
  </v-scale-transition>
</template>

<script>
import OLSphere from 'ol/sphere'
import OLOverlay from 'ol/overlay'

export default {
  props: ['map', 'value', 'feature'],

  data() {
    return {
      tooltip: null,
    }
  },

  computed: {
    area() {
      return this.feature ? OLSphere.getArea(this.feature.getGeometry()) : 0
    },

    tooltipMessage() {
      const area = this.area
      let output = ''

      if (area > 10000) {
        output = `${(Math.round(area / 1000000 * 100) / 100)} km<sup>2</sup>`
      } else {
        output = `${(Math.round(area * 100) / 100)} m<sup>2</sup>`
      }
      
      return output
    },
  },

  methods: {
    createOverlay() {
      const tooltipElement = this.$refs.tooltip
      this.tooltip = new OLOverlay({
        element: tooltipElement,
        offset: [15, 0],
        positioning: 'center-left'
      })

      this.map.addOverlay(this.tooltip)
    },
  },

  watch: {
    map() {
      this.createOverlay()
    },

    feature() {
      if(!this.feature) {
        return
      }

      if(this.feature.getGeometry().getType() == 'Point') {
        return
      }

      const coordinate = this.feature.getGeometry().getInteriorPoint().getCoordinates()
      this.tooltip.setPosition(coordinate)
    },

    value(active) {
      this.tooltip && this.tooltip.setPosition()

      this.$nextTick(() => {
        if(this.feature) {
          if(this.feature.getGeometry().getType() == 'Point') {
            return
          }
          const coordinate = this.feature.getGeometry().getInteriorPoint().getCoordinates()
          this.tooltip.setPosition(coordinate)
        }
      })
    }
  },
}
</script>

<style>
.tooltip-message {
  z-index: 1;
  pointer-events: none;
}

.ol-overlay-container {
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// overlay-feature.vue?046b0220